import * as a1lib from "alt1";
import { ImageDetect } from "alt1";
import { lazy } from "../../Lazy";
import { Vector2 } from "../../math";
import { Log } from "../../util/Log";
export class NeedleImage {
    constructor(url, underlying) {
        this.url = url;
        this.underlying = underlying;
        this._encoded = lazy(() => a1lib.encodeImageString(this.underlying));
    }
    encoded() {
        return this._encoded.get();
    }
    size() {
        return { x: this.underlying.width, y: this.underlying.height };
    }
    static async fromURL(url) {
        return new NeedleImage(url, await ImageDetect.imageDataFromUrl(url));
    }
}
(function (NeedleImage) {
    var log = Log.log;
    class AlternativeSet {
        constructor(needles) {
            this.needles = needles.filter(n => Vector2.eq(needles[0].size(), n.size()));
            if (this.needles.length != needles.length) {
                log().log("ERROR: Needle image set has inconsistent size!", "Initialization", needles.map(n => ({ size: n.size(), url: n.url })));
            }
        }
        static async fromURLs(...urls) {
            return new AlternativeSet(await Promise.all(urls.map(url => NeedleImage.fromURL(url))));
        }
    }
    NeedleImage.AlternativeSet = AlternativeSet;
})(NeedleImage || (NeedleImage = {}));
